import { steps } from './StepNavigation';

const wizardStepValues = steps.map((s) => s.value);

/**
 * True when every step in the onboarding wizard appears in
 * `completed_registration_steps` (order matches `steps`; extra legacy values on
 * the list are ignored).
 */
export function isProviderOnboardingComplete(completedSteps: string[] | undefined): boolean {
  if (!completedSteps?.length) return false;
  return wizardStepValues.every((value) => completedSteps.includes(value));
}

/** 1-based wizard step index of the first step missing from `completed_registration_steps`. If all are present, returns the last step index. */
export function getFirstIncompleteWizardStep(completedSteps: string[] | undefined): number {
  const list = completedSteps ?? [];
  const i = steps.findIndex((s) => !list.includes(s.value));
  return i >= 0 ? i + 1 : steps.length;
}
